export const onboardingShown = 'hasRenterFormOnboardingShown';

export enum ECurrentStep {
  Onboarding = 'onboarding',
  First = 'first',
  Second = 'second',
  Third = 'third',
  Fourth = 'fourth',
}
